module.exports = __webpack_public_path__ + "static/bg_113_black_strawberry-856a5fdb96b9c5816f79e39bfedf1e2e.webp";